module.exports = __webpack_public_path__ + "static/media/next.e48e27f9.svg";